import axios from 'axios'
import router from '../../router'

const state = {
  pusher_auth: 'test',
  prev_page: {name: '', fullPath: '', force: null},
  seller_job_types: [],
  clothes_types: [],
  VIP_discount: [],
}

const getters = {

}

const mutations = {
  setPrevPage(state, from) {
    Object.assign(state.prev_page, from)
  }
}

const actions = {
  getSellerJobTypes({ commit }) {
    return axios.get('/seller_job_type').then(response => {
      state.seller_job_types = response.data
    })
  },
  getClothesTypes({ commit }) {
    return axios.get('/clothes_type').then(response => {
      state.clothes_types = response.data
    })
  },
  getVIPDiscount({ commit }) {
    return axios.get('/member/vip/discount/list').then(response => {
      state.VIP_discount = response.data
    })
  },
  setPrevPage({ commit }, from) {
    commit('setPrevPage', from)
  },
  viewCount({ commit }, id) {
    return axios.get(`/product/view/${id}`)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}